import React, { PureComponent } from 'react'
import { Trans } from '@lingui/react'
import get from 'lodash/get'

import CardLogo from 'client/shared/blocks/stripe-credit-card/card-logo'

import './subscription-logo.styl'

import {
  RecurrentSubscriptionType,
  NonRecurrentSubscriptionType,
  RecurrentSubscriptionMeta,
} from 'client/shared/types/subscription'

type Props = {
  system: RecurrentSubscriptionType | NonRecurrentSubscriptionType
  meta?: RecurrentSubscriptionMeta | null | undefined
}

const systems = {
  android_inapp: 'renderAndroid',
  androidinapp: 'renderAndroid',
  inapp: 'renderApple',
  azercellrecurrent: 'renderAzercell',
  kcellbundlerecurrent: 'renderKcell',
  kcellrecurrent: 'renderKcell',
  mtsbyrecurrent: 'renderMTS',
  paypal: 'renderPaypal',
  plusbogbundlerecurrent: 'renderPlusbog',
  promo: 'renderPromo',
  cards: 'renderStripe',
  telenor: 'renderYettel',
  telenor_bulgaria: 'renderYettel',
  yettel_hungary: 'renderYettel',
  telenor_montenegro: 'renderOne',
  telmorebundlerecurrent: 'renderTelmore',
  youseebundlerecurrent: 'renderYousee',
  braintree_card: 'renderDefault',
  mtn_ghana: 'renderMTNGhana',
}

class SubscriptionLogo extends PureComponent<Props> {
  render(): JSX.Element {
    const renderer = systems[this.props.system] || 'renderDefault'

    return this[renderer]()
  }

  renderStripe(): JSX.Element | null {
    const paymentSystem = get(this.props, 'meta.card.brand')

    if (paymentSystem) {
      return <CardLogo paymentSystem={paymentSystem} />
    }
    return null
  }

  renderApple(): JSX.Element {
    return (
      <div className="subscription-logo_apple">
        <span className="subscription-logo__text">App Store</span>
      </div>
    )
  }

  renderAndroid(): JSX.Element {
    return (
      <div className="subscription-logo_android">
        <span className="subscription-logo__text">Google Market</span>
      </div>
    )
  }

  renderPaypal(): JSX.Element {
    return <div className="subscription-logo_paypal" />
  }

  renderKcell(): JSX.Element {
    return <div className="subscription-logo_kcell" />
  }

  renderAzercell(): JSX.Element {
    return <div className="subscription-logo_azercell" />
  }

  renderMTS(): JSX.Element {
    return <div className="subscription-logo_mts" />
  }

  renderTelmore(): JSX.Element {
    return <div className="subscription-logo_telmore" />
  }

  renderOne(): JSX.Element {
    return <div className="subscription-logo_one" />
  }

  renderYettel(): JSX.Element {
    return <div className="subscription-logo_yettel" />
  }

  renderYousee(): JSX.Element {
    return <div className="subscription-logo_yousee" />
  }

  renderPlusbog(): JSX.Element {
    return <div className="subscription-logo_plusbog" />
  }

  renderBeelineUz(): JSX.Element {
    return <div className="subscription-logo_beeline-uz" />
  }

  renderMTNGhana(): JSX.Element {
    return <div className="subscription-logo_mtn-ghana" />
  }

  renderPromo(): JSX.Element {
    return (
      <div className="subscription-logo_promo">
        <Trans id="plan.active_promo" />
      </div>
    )
  }

  renderDefault(): null {
    return null
  }
}

export default SubscriptionLogo
